import React, { useEffect } from "react";

declare global {
  interface Window {
    startAnymindTS: () => void;
    anymindTS: {
      dispose: () => void;
    };
    gtag: (
      event: string,
      page_view: string,
      parameters: { [key: string]: any }
    ) => void;
  }
}
const AdPage: React.FC<{ id_name?: string }> = ({ id_name = "ad_sample" }) => {
  useEffect(() => {
    // 初始化 Google Analytics 页面视图
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: window.location.pathname,
        page_title: document.title,
      });
      console.log("GA4 Page View Logged!");
    }

    // 在组件挂载后启动 ATS
    try {
      if (window.startAnymindTS) {
        window.startAnymindTS();
        console.log("ATS Initialized!");
      }
    } catch (e) {
      console.error("Error initializing ATS:", e);
    }

    // 在组件卸载时清理 ATS
    return () => {
      if (window.anymindTS && window.anymindTS.dispose) {
        window.anymindTS.dispose();
        console.log("ATS Disposed!");
      }
    };
  }, []); // 空依赖数组确保只在挂载和卸载时运行

  return (
    <div className="flex flex-col items-center">
      {/* 广告容器，ATS 会将广告注入到此元素中 */}
      <div
        // id="ad_sample"
        id={id_name}
        className="flex justify-center items-center w-full py-0 bg-transparent"
      >
        {/* Advertisement Container */}
      </div>
    </div>
  );
};

export default AdPage;
